(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cw-icons-row"] && !Shopify.designMode) return;
  try {
    
  class CwIconsRow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cw-ir__grid');
      this.dots = Array.from(this.querySelectorAll('.cw-ir__dot'));
      if (!this.track || this.dots.length < 2) return;

      this.slides = Array.from(this.track.children);
      this.handleScroll = this.handleScroll.bind(this);
      this.track.addEventListener('scroll', this.handleScroll, { passive: true });

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          const slide = this.slides[i];
          if (!slide) return;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollTo({
            left: slide.offsetLeft - this.track.offsetLeft,
            behavior: reduce ? 'auto' : 'smooth',
          });
        });
      });

      this.setActive(0);
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        const left = this.track.scrollLeft;
        let best = 0;
        let min = Infinity;
        this.slides.forEach((slide, i) => {
          const delta = Math.abs(slide.offsetLeft - this.track.offsetLeft - left);
          if (delta < min) { min = delta; best = i; }
        });
        this.setActive(best);
      });
    }

    setActive(index) {
      if (this.current === index) return;
      this.current = index;
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        if (i === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }
  }

  if (!customElements.get('cw-icons-row')) {
    customElements.define('cw-icons-row', CwIconsRow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
